// @module SuiteDB.SDBOtherCharges.SDBOtherCharges
define("SuiteDB.SDBOtherCharges.SDBOtherCharges.View", [
  "suitedb_sdbothercharges_sdbothercharges.tpl",
  "Backbone",
  "Profile.Model",
  "LiveOrder.Model",
  "ExternalVendor.Inventory.SS2Model",
  "SDB.SDBLocations.Model",
  "Utils",
  "SuiteDB.SDBOtherCharges.SDBOtherCharges.Model",
], function (
  suitedb_sdbothercharges_sdbothercharges_tpl,
  Backbone,
  ProfileModel,
  LiveOrderModel,
  ExternalVendorInventorySS2Model,
  SDBLocationsModel,
  Utils,
  SDBOtherChargesModel
) {
  "use strict";

  // @class SuiteDB.SDBOtherCharges.SDBOtherCharges.View @extends Backbone.View
  return Backbone.View.extend({
    template: suitedb_sdbothercharges_sdbothercharges_tpl,
    initialize: function initialize(options) {
      var self = this;
      self.chargeItems = [];

      self.model = SDBOtherChargesModel.getInstance();
      self.model.set("currentView", self);
      var chargeItems = self.model.get("chargeItems");

      var quoteToSalesOrderModel = self.model.get("QuoteToSalesOrderModel");
      var quoteSummaryView = self.model.get("quoteSummaryView");
      var Model = ExternalVendorInventorySS2Model.getInstance();

      var resetInfo = function resetInfo(options) {
        self.charge = undefined;
        self.chargeItems = [];
        options.custbody_sdb_other_charges_data = "[]";
        Model.set("otherCharges", 0);
      };

      /** @type {LiveOrder.Model} */
      var LiveOrder = LiveOrderModel.getInstance();
      if (quoteToSalesOrderModel) {
        LiveOrder = quoteToSalesOrderModel;
      }

      /** @type {Profile.Model} */
      var Profile = ProfileModel.getInstance();

      var isLoggedIn = Profile.get("isLoggedIn");
      if (isLoggedIn !== "T") {
        resetInfo(LiveOrder.get("options"));
        return;
      }

      /** @type {SDB.Locations.Model} */
      var Locations = SDBLocationsModel.getInstance();

      var selectChargeItem = function selectChargeItem() {
        if (!chargeItems) chargeItems = self.model.get("chargeItems");
        if (!chargeItems) return;
        var options = LiveOrder.get("options");
        var state;
        var locationSelected = Locations.getSelectedLocation();

        if (locationSelected) {
          state = locationSelected.addrFields.state;
        } else if (!Utils.isInShopping()) {
          var addressId = LiveOrder.get("shipaddress");
          var addresses = JSON.parse(
            JSON.stringify(
              Profile.get("addressbook") || Profile.get("addresses")
            )
          );
          if (quoteToSalesOrderModel) {
            addresses = JSON.parse(
              JSON.stringify(quoteToSalesOrderModel.get("addresses"))
            );
          }
          if (!addressId || !addresses.length) {
            resetInfo(options);
            return;
          }

          _.find(addresses, function (addrs) {
            if (addrs.internalid == addressId) {
              state = addrs.state;
            }
          });
        }

        if (!state || !chargeItems[state]) {
          resetInfo(options);
          return;
        }

        var lines = LiveOrder.get("lines").models;
        var totalCharge = 0;
        var chargeitemsApplied = [];

        lines.forEach(function (line) {
          var itemClass = line.get("item").get("class");
          var quantity = Number(line.get("quantity"));
          if (itemClass) {
            for (var i = 0; i < chargeItems[state].length; i++) {
              var price = Number(chargeItems[state][i].chargeItem.price);
              var taxRate = Number(chargeItems[state][i].tax.rate);
              var name = chargeItems[state][i].chargeItem.name;

              var priceTaxed = price + price * (taxRate / 100);
              var chargeType = chargeItems[state][i].type.toLowerCase();

              if (itemClass.toLowerCase().indexOf(chargeType) != -1) {
                var individualCost = quantity * priceTaxed;
                totalCharge += individualCost;
                var index = _.findIndex(self.chargeItems, function (item) {
                  return item.name == name;
                });
                if (index != -1) {
                  self.chargeItems[index].cost = Utils.formatCurrency(
                    Number(self.chargeItems[index].cost.replace("$", "")) +
                      individualCost
                  );
                } else {
                  self.chargeItems.push({
                    cost: Utils.formatCurrency(individualCost),
                    name: name,
                  });
                  chargeitemsApplied.push({
                    type: chargeType,
                    id: chargeItems[state][i].chargeItem.id,
                  });
                }
              }
            }
          }
        });

        if (totalCharge > 0) self.charge = Utils.formatCurrency(totalCharge);
        options.custbody_sdb_other_charges_data = JSON.stringify(
          chargeitemsApplied || []
        );

        var orderTotal = LiveOrder.attributes.summary.total;
        var newOrderTotal = totalCharge + orderTotal;
        LiveOrder.attributes.summary.total_formatted =
          Utils.formatCurrency(newOrderTotal);
        Model.set("otherCharges", totalCharge);
        if (quoteToSalesOrderModel) {
          if (quoteSummaryView) {
            self.model.unset("quoteSummaryView");
            quoteSummaryView.render();
          }
        }
      };
      self.selectChargeItem = selectChargeItem;

      if (!chargeItems) {
        resetInfo(LiveOrder.get("options"));
        return;
      }

      selectChargeItem();
    },
    events: {},
    bindings: {},
    childViews: {},
    getContext: function getContext() {
      return {
        charge: this.charge,
        chargeItems: this.chargeItems,
      };
    },
  });
});
